module.exports = __webpack_public_path__ + "static/media/arrow-right-circle.b6e6a02e.svg";